import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { checkDoShowAgentCommission } from '../../../../../store/slices/user';
import currencySymbol from '../../../../../helpers/currencySymbol';
import { TravelTypes } from '../../../../../constants';
import getCommissionLabel from '../../../../../helpers/getCommissionLabel';

const AgentCommission = ({
  agentCommission, isCommissionable, className, currencyCode,
  agentCommissionPercentage, doShowCommissionAsPercentage,
}) => {
  const { travelAgency } = useSelector((store) => store.user);

  const doShowAgentCommission = useSelector(checkDoShowAgentCommission);
  if (!doShowAgentCommission) {
    return <></>;
  }

  const shouldShowPercentage = doShowCommissionAsPercentage && agentCommissionPercentage > 0;

  return isCommissionable !== null ? (
    <div className={`${className}`}>
      {agentCommission
        ? (
          <>
            <span>
              {getCommissionLabel(travelAgency, TravelTypes.hotel)}
              :
              {' '}
            </span>
            {shouldShowPercentage ? (
              <NumberFormat
                value={agentCommissionPercentage}
                displayType="text"
                decimalScale="1"
                suffix="%"
              />
            ) : (
              <NumberFormat
                value={agentCommission}
                prefix={currencySymbol(currencyCode)}
                displayType="text"
                thousandSeparator
                fixedDecimalScale="true"
                decimalScale="2"
              />
            )}
          </>
        )
        : (<span>{isCommissionable ? 'Commissionable' : 'Non-commissionable'}</span>)}
    </div>
  ) : <></>;
};

AgentCommission.propTypes = {
  agentCommission: PropTypes.number,
  isCommissionable: PropTypes.bool,
  className: PropTypes.string,
  currencyCode: PropTypes.string,
  agentCommissionPercentage: PropTypes.number,
  doShowCommissionAsPercentage: PropTypes.bool,
};

AgentCommission.defaultProps = {
  className: '',
  isCommissionable: null,
  agentCommission: null,
  currencyCode: undefined,
  agentCommissionPercentage: null,
  doShowCommissionAsPercentage: false,
};

export default AgentCommission;
